import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { CalendarCheck2, AlertTriangle, Loader2, RefreshCw } from "lucide-react";

// NEVER SILENT (his plan, S2.2): when the list was last worked out — and, when a night was missed, why.
const when = (at) => (at ? new Date(at).toLocaleString([], { dateStyle: "medium", timeStyle: "short" }) : "");

export function NightLine({ night: given, canWorkOut, onDone, testid = "sales-night" }) {
  const [busy, setBusy] = useState(false);
  const [night, setNight] = useState(given);
  useEffect(() => setNight(given), [given]);
  const running = !!night?.running;
  // while the list is being worked out, look again every 3 s; when it is done, the list is read again
  useEffect(() => {
    if (!running) return undefined;
    const t = setInterval(() => api.get("/sales/recommended/night").then((r) => {
      setNight(r.data);
      if (!r.data.running) onDone?.();
    }).catch(() => {}), 3000);
    return () => clearInterval(t);
  }, [running]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!night) return null;
  const workOut = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/sales/recommended/work-out");
      toast.success(data.message);
      setNight({ ...night, running: true, missed: null });
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const bad = !!night.missed;
  return (
    <div data-testid={testid} className={`flex flex-wrap items-center gap-2 rounded-lg border px-3 py-2 text-sm ${bad ? "border-amber-300 bg-amber-50 text-amber-950" : "border-slate-200 bg-slate-50 text-slate-700"}`}>
      {bad ? <AlertTriangle className="w-4 h-4 shrink-0" /> : <CalendarCheck2 className="w-4 h-4 shrink-0 text-emerald-700" />}
      <span data-testid={`${testid}-words`} className="flex-1 min-w-[200px]">
        {night.running ? "The list is being worked out right now." : bad ? <><b>Not worked out as planned.</b> {night.missed}{night.last_at ? ` The list below is from ${when(night.last_at)}.` : ""}</>
          : <>Worked out {when(night.last_at)}{night.looked_at != null ? ` · ${night.looked_at.toLocaleString()} parts looked at` : ""}. It is worked out again every night at 02:30.</>}
      </span>
      {canWorkOut && (
        <button type="button" data-testid={`${testid}-work-out`} disabled={busy || night.running} onClick={workOut}
          className="inline-flex items-center gap-1.5 h-11 px-3 rounded-lg border-2 border-slate-300 bg-white text-slate-800 text-sm font-bold hover:bg-slate-50 disabled:opacity-40">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <RefreshCw className="w-4 h-4" />}Work it out now</button>
      )}
    </div>
  );
}
